import { useEffect, useState } from "react";
import { TID } from "@/lib/testIds";

export default function Nav({ onBookClick, onTradeClick }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid={TID.nav.root}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-md border-b border-stone/60"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={TID.nav.logo}
          className={`font-display text-[15px] md:text-base tracking-[0.28em] uppercase ${
            scrolled ? "text-charcoal" : "text-cream"
          }`}
        >
          Mirabilis
        </a>
        <nav
          className={`hidden lg:flex items-center gap-8 text-[12px] tracking-[0.18em] uppercase ${
            scrolled ? "text-ink" : "text-cream/80"
          }`}
        >
          <button
            data-testid={TID.nav.homeownersLink}
            onClick={() => scrollTo("audiences")}
            className="hover:text-brassDark transition-colors"
          >
            Homeowners
          </button>
          <button
            data-testid={TID.nav.buildersLink}
            onClick={() => scrollTo("builder-confidence")}
            className="hover:text-brassDark transition-colors"
          >
            Builders
          </button>
          <button
            data-testid={TID.nav.storyLink}
            onClick={() => scrollTo("story")}
            className="hover:text-brassDark transition-colors"
          >
            Story
          </button>
          <button
            data-testid={TID.nav.portfolioLink}
            onClick={() => scrollTo("portfolio")}
            className="hover:text-brassDark transition-colors"
          >
            Portfolio
          </button>
          <button
            data-testid={TID.nav.processLink}
            onClick={() => scrollTo("process")}
            className="hover:text-brassDark transition-colors"
          >
            Process
          </button>
        </nav>
        <div className="flex items-center gap-5">
          <button
            data-testid={TID.cta.tradeBtn}
            onClick={onTradeClick}
            className={`hidden md:inline text-[11px] tracking-[0.22em] uppercase border-b pb-1 transition-colors ${
              scrolled
                ? "text-ink border-ink/40 hover:text-brassDark hover:border-brassDark"
                : "text-cream/80 border-cream/40 hover:text-brass hover:border-brass"
            }`}
          >
            For Builders
          </button>
          <button
            data-testid={TID.nav.bookBtn}
            onClick={onBookClick}
            className={`group inline-flex items-center gap-2 text-[12px] md:text-[13px] tracking-[0.22em] uppercase pb-1 border-b transition-colors ${
              scrolled
                ? "text-charcoal border-charcoal/60 hover:border-brassDark hover:text-brassDark"
                : "text-cream border-cream/60 hover:border-brass hover:text-brass"
            }`}
          >
            Book Consult
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
